import KFocused from '../../core/mixins/focused/KFocused'
import KControl from '../../core/mixins/control/KControl'
import KEmitter from '../../core/mixins/emitter/KEmitter'
import KCasSection from './CasSection'
import KPopover from '../popover'
import _ from 'lodash'
import { Tag } from '../tag'
import Icon from '../icon'

export default {
  name: 'KCascade',
  componentName: 'KCascade',
  components: { KCasSection },
  mixins: [KFocused, KControl, KEmitter],
  props: {
    value: {
      type: Array,
      // []
      default() {
        return []
      },
    },
    selectedNodes: {
      type: Array,
      // []
      default() {
        return []
      },
    },
    title: {
      type: String,
      default: '请选择',
    },
    data: {
      type: Array, // 数据源
      // []
      default() {
        return []
      },
    },
    tabBy: {
      type: Function,
      default: null,
    },
    groupBy: {
      type: Function,
      default: null,
    },
    limit: {
      type: Number,
      default: 10,
    },
    mode: {
      type: String,
      default: 'isolate',
      validator(value) {
        return ['tree', 'isolate'].indexOf(value) > -1
      },
    },
  },
  data() {
    return {
      visible: false,
      activeTab: null,
      nodesValue: [],
    }
  },
  computed: {
    inputValue() {
      return _.map(this.selectedNodes, node => {
        return node.label
      })
    },
  },
  watch: {
    visible(val) {
      if (val && !this.activeTab && _.isFunction(this.tabBy)) {
        const tabs = this.tabBy(this.data)
        if (tabs && tabs.length > 1) {
          this.activeTab = tabs[1].name
          _.delay(() => {
            this.activeTab = tabs[0].name
          }, 0)
        }
      }
    },
    data(val) {
      if (_.isEmpty(val)) return
      let data = []
      if (_.isFunction(this.tabBy)) {
        _.forEach(this.tabBy(this.data), tabItem => {
          data = data.concat(tabItem.children)
        })
      } else {
        data = this.data
      }
      _.forEach(this.value, v => {
        const n = this.tryFindNode(data, v)
        n && this.selectedNodes.push(n)
      })
    },
  },
  render() {
    const input = this.renderInput()
    const content = this.renderContent()
    return (
      <KPopover
        ref="popover"
        value={this.visible}
        popperClass="km-cascade__popover"
        trigger="click"
        widthEqualToReference={false}
        onInput={this.handleVisibleChange}
        placement="bottom-start"
      >
        <template slot="reference">{input}</template>
        {content}
      </KPopover>
    )
  },
  mounted() {
  },
  methods: {
    renderInput() {
      const labels = this.renderLabels()
      const arrow = this.renderArrow()
      const css = {
        'km-cascade': true,
      }
      return <k-input
        class={{ ...css }}
        readonly="readonly"
        title={this.inputValue}
        type="primary"
      >
        {labels}
        {arrow}
      </k-input>
    },
    renderLabels() {
      if (!this.inputValue) {
        return
      }
      const labels = _.map(this.selectedNodes, (option, index) => {
        return this.renderLabel(option, index)
      })

      return (<div class="km-select-labels">
        {labels}
      </div>)
    },
    renderLabel(option, index) {
      return <Tag
        key={index}
        class="km-select__label"
        size="small"
        clearable
        onClear={() => {
          this.handleLabelClear(option)
        }}
        nativeOnClick={(e) => {
          e.stopPropagation()
        }}
      >
        {option.label || option.value}
      </Tag>
    },
    renderArrow() {
      return (
        <template slot="suffix">
          <Icon
            icon={this.visible ? 'chevron-up' : 'chevron-down'}
            class="km-select__arrow"
          />
        </template>
      )
    },
    renderContent() {
      const data = {
        attrs: {},
        props: {
          data: this.data,
          tabBy: this.tabBy,
          groupBy: this.groupBy,
          checked: this.value,
          limit: this.limit,
          mode: this.mode,
          activeTab: this.activeTab,
        },
        on: {
          nodeClick: this.handleNodeClick,
        },
      }
      return (
        <KCasSection {...data}>
          {this.$slots.default}
        </KCasSection>
      )
    },
    handleVisibleChange(val) {
      this.visible = val
    },
    handleNodeClick(node) {
      switch (this.mode) {
        case 'tree':
          this.doTreeClick(node)
          break
        default:
          this.doIsolateClick(node)
      }
      this.$nextTick(() => {
        this.$refs.popover && this.$refs.popover.updatePosition()
      })
      this.$emit('change', this.selectedNodes)
    },
    doTreeClick(node) {
      const index = _.indexOf(this.value, node.value)
      if (index > -1) {
        this.value.splice(index, 1)
        this.selectedNodes.splice(index, 1)
        this.tryRemoveChildren(node)
        this.tryRemoveParent(node)
      } else {
        this.value.push(node.value)
        this.selectedNodes.push(node)
        this.tryAddChildren(node)
        this.tryAddParent(node)
      }
    },
    doIsolateClick(node) {
      const index = _.indexOf(this.value, node.value)
      if (index > -1) {
        this.value.splice(index, 1)
        this.selectedNodes.splice(index, 1)
      } else {
        this.limit === 1 && this.value.splice(0) && this.selectedNodes.splice(0)
        this.value.push(node.value)
        this.selectedNodes.push(node)
        if (this.limit !== 1) {
          this.tryRemoveChildren(node)
          this.tryRemoveParent(node)
        }
      }
    },
    tryRemoveChildren(node) {
      if (!_.isEmpty(node.children)) {
        _.forEach(node.children, n => {
          const index = _.indexOf(this.value, n.value)
          if (index > -1) {
            this.value.splice(index, 1)
            this.selectedNodes.splice(index, 1)
          }
          this.tryRemoveChildren(n)
        })
      }
    },
    tryAddChildren(node) {
      if (!_.isEmpty(node.children)) {
        _.forEach(node.children, n => {
          const index = _.indexOf(this.value, n.value)
          if (index < 0) {
            this.value.push(n.value)
            this.selectedNodes.push(n)
          }
          this.tryAddChildren(n)
        })
      }
    },
    tryRemoveParent(node) {
      if (node.parent) {
        const index = _.indexOf(this.value, node.parent.value)
        if (index > -1) {
          this.value.splice(index, 1)
          this.selectedNodes.splice(index, 1)
        }
        this.tryRemoveParent(node.parent)
      }
    },
    tryAddParent(node) {
      if (node.parent) {
        const parent = this.tryFindNode(this.data, node.parent.value)
        const allChildrenChecked = _.every(parent.children, n => {
          return _.indexOf(this.value, n.value) > -1
        })
        if (allChildrenChecked) {
          this.value.push(parent.value)
          this.selectedNodes.push(parent)
          this.tryAddParent(parent)
        }
      }
    },
    tryFindNode(nodes, v, parent) {
      let node = _.find(nodes, n => n.value === v)
      if (node) {
        node = {
          label: node.label,
          value: node.value,
          children: node.children,
        }
        node.parent = parent
        return node
      } else {
        _.forEach(nodes, n => {
          node = this.tryFindNode(n.children, v, { label: n.label, value: n.value, parent: parent })
          if (node) return false
        })
      }
      return node
    },
    handleLabelClear(option) {
      this.handleNodeClick(option)
    },
  },
}
